import "./component/homepage-slideshow.es6";
import "./UI/expander-menu.es6";
import "./UI/toggler.es6";
import "./UI/appear.es6";
import "./UI/anim.es6";
import "./UI/image-popup.es6";
import "./UI/parallax.es6";
import "./UI/contact-button.es6";
import "./UI/menu.es6";
import "./UI/scroll-visibility.es6";

if(navigator.userAgent.includes("Safari/605.1.15") && !navigator.userAgent.includes("Chrome")) {
	oldSafariCloseButtonFix();

	if(navigator.userAgent.includes("Version/14")) {
		oldSafariLayoutFix();
	}
}

function oldSafariCloseButtonFix() {
}

function oldSafariLayoutFix() {
	document.querySelectorAll("dialog").forEach(function(dialog) {
		dialogPolyfill.registerDialog(dialog);
	});
}


location.pathname === "/" && (function() {
	document.body.classList.add("at-top");

	window.addEventListener("scroll", e => {
		if(window.scrollY > 570) {
			document.body.classList.remove("at-top");
		}
		else {
			document.body.classList.add("at-top");
		}
	})
})();

document.querySelectorAll("dialog").forEach(dialog => {
	dialog.addEventListener("click", clickDialog);
});

function clickDialog() {
	let rect = this.getBoundingClientRect();
	let isInDialog=(rect.top <= event.clientY && event.clientY <= rect.top + rect.height
		&& rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
	if(!isInDialog) {
		this.close();
	}
}

document.querySelectorAll(".popup-services .details").forEach(detailsDiv => {
	let dialog = detailsDiv.querySelector("dialog");
	let summary = detailsDiv.querySelector(".summary");

	dialog.addEventListener("close", e => {
		document.documentElement.style.overflow = "initial";
	});

	summary.addEventListener("click", e => {
		dialog.showModal();
		dialog.scrollTo(0, 0);
		document.documentElement.style.overflow = "hidden";
	});
	dialog.querySelector(".close").addEventListener("click", e => {
		dialog.close();
	})
})
